import { Ads, useMediaQuery } from "@sphtech/dmg-design-system";

import styles from "../homelayout.module.css";

type Props = {
  adConfig?: {
    type: keyof typeof Ads;
    showOnMobile?: boolean;
    showOnDesktop?: boolean;
  };
};

export function HomeAds({ adConfig }: Props) {
  const mobileUp = useMediaQuery("screen and (min-width: 1000px)");
  if (!adConfig) {
    return null;
  }

  const AdComponent = Ads[adConfig.type];

  // safety check to ensure the ad component exists
  if (typeof AdComponent !== "function") {
    console.warn(`Ad component ${adConfig.type} not found.`);
    return null;
  }

  return (adConfig.showOnDesktop && mobileUp) ||
    (adConfig.showOnMobile && !mobileUp) ? (
    <div className={styles.homeAdsContainer}>
      <AdComponent />
    </div>
  ) : null;
}
